import { getConfig } from 'src/utilities/config';

export function getAutoPaymentTerms(): string {
  const { customerServiceNumber } = getConfig();
  return `By setting up auto payment, you authorize Grubhub to charge the
    designated credit card for the total amount due on each invoice.
    Payment terms and invoice frequency shall continue in accordance with
    the terms set forth in the written agreement between you and Grubhub.
    Your authorization for auto-payment will remain in effect until you
    choose to opt-out of this feature. Contact your client success manager
    at ${customerServiceNumber} with any questions regarding your written
    agreement, invoice terms, and available payment options.`;
}
